import { Notice } from '../Notice/Notice'
import { Button } from 'blaze-ui/Button'
import { GraduationCap } from 'blaze-ui/icons'
import useOpenWindowSafely from 'hooks/useOpenWindowSafely'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

interface IntegrationNoticeProps {
  message: React.ReactNode
  connectionGuideLink?: string
  variant?: 'warning' | 'danger'
  title?: string
}

export const IntegrationNotice = ({
  message,
  connectionGuideLink,
  variant = 'warning',
  title = 'Important note',
}: IntegrationNoticeProps) => {
  const openWindowSafely = useOpenWindowSafely()
  const { isMobile } = useResponsiveDesign()

  return (
    <Notice message={message} variant={variant} title={title}>
      {connectionGuideLink && (
        <div>
          <Button
            fullWidth={isMobile}
            variant="secondary"
            frontIcon={GraduationCap}
            size="sm"
            onPress={() => openWindowSafely(connectionGuideLink)}
          >
            See Connection Guide
          </Button>
        </div>
      )}
    </Notice>
  )
}
